<script setup>
import { ref } from 'vue';
import { useAuthStore } from '@/stores/auth';
import MenuBar from '@/components/navigation/MenuBar.vue';
import SidebarMenu from '@/components/navigation/SidebarMenu.vue';
import AppContainer from '@/components/AppContainer.vue';
import GlobalDialog from '@/components/widgets/dialogs/GlobalDialog.vue';
import GlobalLoader from '@/components/widgets/dialogs/GlobalLoader.vue';

const showSidebar = ref(false);
const auth = useAuthStore();

// Solution: Use a more explicit toggle function
const toggleSidebar = () => {
    showSidebar.value = !showSidebar.value
}
</script>

<template>
    <v-layout v-if="auth.isAuthenticated">
        <MenuBar @toggle-sidebar="toggleSidebar"></MenuBar>

        <SidebarMenu v-model:show="showSidebar"></SidebarMenu>

        <v-main>
            <AppContainer>
                <RouterView />
            </AppContainer>
        </v-main>

        <GlobalDialog />
        <GlobalLoader />
    </v-layout>
</template>

<style lang="scss" scoped>
:deep(.v-toolbar__extension) {
    background-color: white;
    padding: 0px 10px;
    color: #2f3030;
    border-bottom: 1px solid #ebeaecd9;
}

.v-main {
    min-height: 100vh;
    background-color: #f4f6f7d9;
    padding-bottom: 30px;
}
</style>
